export default __webpack_public_path__ + "static/media/check-mailbox-sm.15897263.png";